/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * CacheStatus specifies status of the cache deployment.
 * @export
 * @enum {string}
 */

export const DboV1CacheStatus = {
    Undeployed: 'Undeployed',
    Error: 'Error',
    Ready: 'Ready',
    Pending: 'Pending',
    Active: 'Active'
} as const;

export type DboV1CacheStatus = typeof DboV1CacheStatus[keyof typeof DboV1CacheStatus];



